import { request } from '@blade/common';
/*
获取角色列表 -zrl
*/
export const getList = (data) => request({
    url: '/api/user-management/api/v1/ums/role/list',
    method: 'POST',
    data
});
/*
  获取权限角色列表 -zrl
*/
export const getPermissionList = () => request({
    url: '/api/user-management/api/v1/ums/role/user/permissions',
    method: 'GET',
});
/*
/*
  获取权限角色详情列表 -zrl
*/
export const getDetailPermissionList = (roleId) => request({
    url: `/api/user-management/api/v1/ums/role/${roleId}`,
    method: 'GET',
});
/*
  创建角色 -zrl
*/
export const createRole = (data) => request({
    url: '/api/user-management/api/v1/ums/role',
    method: 'POST',
    data
});
/*
编辑角色 -zrl
*/
export const editRole = (data) => request({
    url: '/api/user-management/api/v1/ums/role',
    method: 'PUT',
    data
});
/*
删除角色 -zrl
*/
export const deleteRole = (roleId) => request({
    url: `/api/user-management/api/v1/ums/role/${roleId}`,
    method: 'POST',
});
/*
启用角色 -zrl
*/
export const enableRole = (data) => request({
    url: '/api/user-management/api/v1/ums/role/enable',
    method: 'POST',
    data
});
/*
禁用角色 -zrl
*/
export const disableRole = (data) => request({
    url: '/api/user-management/api/v1/ums/role/disable',
    method: 'POST',
    data
});
